import { useFlowsRouteParams } from './useFlowsRouteParams';

/** Base url with flowId and sessionId */
type Response = string;

const useFlowsBaseUrl = (): Response => {
  const { flowId, sessionId } = useFlowsRouteParams();
  const flowsBaseURL = `/flows/${flowId}/questions/${sessionId}`;
  return flowsBaseURL;
};

export default useFlowsBaseUrl;
